import { useTranslation } from 'cng-web-lib'
import UserNamePasswordKeys from 'src/constants/locale/key/UserNamePassword'
import Namespace from 'src/constants/locale/Namespace'


export const useTranslations = () => {

  const { translate } = useTranslation([Namespace.USER_NAME_PASSWORD])

  let userId = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.USER_ID
  )

  let cancel = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.CANCEL
  )

  let forgotPassword = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.FORGOT_PASSWORD
  )

  let submit = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.SUBMIT_BUTTON
  )

  return {
    userId,
    cancel, forgotPassword,
    submit
  }
}